import { executeRequest, JFSRequest } from '@jfs/network'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, sitConfig } from './config'

const updateEntityReq = (data: any, tokens: any) => {
  // const filteredReq = removeEmpty(req)
  const request: JFSRequest<{}> = {
    config: sitConfig(tokens),
    apiPath: APIEndPoints.updateEntity,
    method: 'POST',
    body: data,
    cache: false,
    headers: getHeaders(),
  }
  return executeRequest(request)
    .then((data) => {
      return data
    })
    .catch((err) => {
      throw err
    })
}

export { updateEntityReq }
